export default "__VITE_ASSET__9aeffd2d__"